import React from 'react';
import { DarkeningLayer } from './style';

export const ConditionalOverlayWrapper = ({ isApplied }) => isApplied && <DarkeningLayer />;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/OverlayWrapper.js